import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';

import {
    LOADING,
    SAVE_CURRENT_DB_CAPACITY,
    GET_ALL_SCHEDULED_SETTINGS
} from '../types';
import MessageUtils from '../../utils/MessageUtils';

export const setManualDbScaling = (capacity, callback) => {
    return (dispatch) => {

        const url = `/scheduled-settings/manual-db-scaling`;

        dispatch({ type: LOADING, payload: true });

        axios().put(url, { capacity: +capacity })
            .then(_ => {

                if (callback) {
                    callback();
                }
                MessageUtils.dispatchSuccessMessage(dispatch, 'Capacity set successfully.');
            })
            .catch(_ => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:posSettings.somethingWrong'));
            });
    }
}

export const getCurrentDbCapacity = () => {
    return (dispatch) => {

        const url = `/scheduled-settings/current-db-capacity`;

        axios().get(url)
            .then(res => {
                dispatch({ type: SAVE_CURRENT_DB_CAPACITY, payload: res.data })
                dispatch({ type: LOADING, payload: false });
            })
            .catch(_ => {
                dispatch({ type: LOADING, payload: false });
            })

    }
}

export const getAllScheduledSettings = () => {
    return (dispatch) => {

        const url = `/scheduled-settings`;

        dispatch({ type: LOADING, payload: true });

        axios().get(url)
            .then(res => {
                dispatch({ type: GET_ALL_SCHEDULED_SETTINGS, payload: res.data })
                dispatch({ type: LOADING, payload: false });
            })
            .catch(_ => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:posSettings.somethingWrong'));
            });
    }
}

export const deleteScheduledSetting = (id, callback) => {
    return (dispatch) => {
        const url = `/scheduled-settings/${id}`;

        axios().delete(url)
            .then(_ => {
                MessageUtils.dispatchSuccessMessage(dispatch, 'Settings deleted successfully.');
                if (callback) {
                    callback();
                }
            })
            .catch(_ => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:posSettings.somethingWrong')));
    }
}

export const createUpdateScheduledSetting = (settings, callback) => {
    return (dispatch) => {

        const url = `/scheduled-settings`;

        axios().put(url, settings)
            .then(_ => {
                MessageUtils.dispatchSuccessMessage(dispatch, 'Settings saved successfully.');

                if (callback) {
                    callback();
                }
            })
            .catch(err => {
                if (err.response.data.userMessage) {
                    MessageUtils.dispatchErrorMessage(dispatch, err.response.data.userMessage);

                } else {
                    MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:posSettings.somethingWrong'));
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/systemControl/DbActions.js